const cache = new Map();
const lifetime = 30000;
export const clearQuotationListCache = () => cache.clear();
export function cachedQuotationList(scope) {
  const entry = cache.get(scope);
  return entry && Date.now() - entry.savedAt < lifetime ? entry.rows : null;
}
export async function loadQuotationList(api, { scope, signal, onProgress = ()=>{} }) {
  if(signal?.aborted)return null;
  const {data}=await api.get('quotation/freelance',{signal});
  if(signal?.aborted)return null;
  if(!Array.isArray(data))throw new Error('Liste des devis invalide.');
  const rows=data.map(quotation=>({quotation,client:quotation.client && typeof quotation.client==='object'?quotation.client:{_id:quotation.client}}));
  rows.sort((a,b)=>(new Date(b.quotation.createdAt).getTime()||0)-(new Date(a.quotation.createdAt).getTime()||0));
  cache.set(scope,{rows,savedAt:Date.now()});
  onProgress({rows,completed:rows.length,total:rows.length});
  return {rows,failures:0,error:null};
}
